import { DISCOUNT_CONDITIONS } from 'shared/constants/discountConditions';
import { Utp } from '../Utp';
import * as style from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { IConditions, IUtpItemWithPercent } from 'shared/types/utp';

interface IDiscountConditionsProps {
  device: TDeviceType;
  Item: React.FC<IUtpItemWithPercent>;
  buttonLink: JSX.Element;
  discountConditions: IConditions[];
}

export const DiscountConditions: React.FC<IDiscountConditionsProps> = ({ device, Item, buttonLink }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <Utp
        withoutMargin
        title={device === 'tablet' ? 'Условия получения скидки' : 'Условия программы'}
        items={DISCOUNT_CONDITIONS}
        ItemForRender={Item}
      />
      <div className={style['btn']}>{buttonLink}</div>
    </div>
  );
};
